module.exports = __webpack_public_path__ + "public/files/img/degrees.d7947170.gif";